/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {verifyAccountOwnership} from '../api'

export const useMutationVerifyAccountOwnership = createReactQueryMutationHook('verifyAccountOwnership', verifyAccountOwnership)
